import { render } from "./Peraturan.vue?vue&type=template&id=1c8c370f"
import script from "./Peraturan.vue?vue&type=script&lang=js"
export * from "./Peraturan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__